import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getIsSummaryPanelOpen = createSelector(
  (state: Store) => state.dealManagement.plannerSettings.isSummaryPanelOpen,
  (isSummaryPanelOpen) => isSummaryPanelOpen,
);
